module.exports = __webpack_public_path__ + "static/img/home_4.3796b11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/home_4.png
// module id = bp+b
// module chunks = 1